import { inferLocaleFromLocalizedPathRoot } from './infer-locale-from-localized-path-root';

export type SupportedLocale = 'en' | 'fi' | 'sv';

/**
 * Resolve route locale from page context + URL.
 *
 * - Physical `/fi/*` and `/sv/*` URLs always win over a wrong `locale: "en"` in context.
 * - `/en/*` with `locale: "fi"|"sv"` trusts context (Vike often exposes logical English paths).
 * - Unprefixed roots that only exist for FI/SV (`tyoelama`, `arbetsliv`, `tyopaikat`, …) win over
 *   `locale: "en"`.
 * - English logical segments (`privacy`, `resources`, …) + `locale: "fi"|"sv"` trust context.
 */
export function resolvePageLocale(input: {
  locale?: string;
  urlPathname?: string;
}): SupportedLocale {
  const fromContext = input.locale;
  const pathname = input.urlPathname;
  const firstSegment = pathname?.split('?')[0].split('/').filter(Boolean)[0]?.toLowerCase();

  if (firstSegment === 'fi' || firstSegment === 'sv') {
    return firstSegment;
  }

  if (firstSegment === 'en') {
    if (fromContext === 'fi' || fromContext === 'sv') {
      return fromContext;
    }
    return 'en';
  }

  const inferredRoot = firstSegment ? inferLocaleFromLocalizedPathRoot(firstSegment) : null;

  // Unprefixed /tyoelama, /arbetsliv, /tyopaikat, … — trust path over wrong context "en"
  if (inferredRoot === 'fi' || inferredRoot === 'sv') {
    return inferredRoot;
  }

  if (fromContext === 'fi' || fromContext === 'sv') {
    return fromContext;
  }

  if (inferredRoot === 'en') {
    return 'en';
  }

  if (fromContext === 'en') {
    return 'en';
  }

  return 'en';
}
